import { z } from 'zod';
import { BusinessCaseSchema, ProjectNumberSchema } from '@schuettflix/interfaces';
import { CustomerInfoSchema } from '@/shared/models/ContextDataModel/interfaces/entities/customer-info.ts';
import { FinanceSettingsSchema } from '@/shared/models/ContextDataModel/interfaces/entities/finance-settings.ts';
import { ProductConfigurationSchema } from '@/shared/models/ContextDataModel/interfaces/entities/product-configuration.ts';

export const PositionConfigurationSchema = z.object({
    projectNumber: ProjectNumberSchema,
    customer: CustomerInfoSchema,
    businessCase: BusinessCaseSchema,
    platformOrganizationId: z.number().positive(),
    marketCode: z.string(),
    validFrom: z.coerce.date(),
    validTo: z.coerce.date(),
    active: z.boolean(),
    note: z.string().optional(),
    salesforceOpportunityId: z.string().optional(),
    financeSettings: z.array(FinanceSettingsSchema),
    productConfigurations: z.array(ProductConfigurationSchema),
});
